// angular
import { Component } from '@angular/core';

import { TreeType } from '@aa/common';

// local
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';

@Component({
  selector: 'aa-qna-accessibility',
  templateUrl: './accessibility.component.html'
})
export class QnaAccessibilityPageComponent extends AbstractQnaComponent {

  public readonly TreeType = TreeType;

  constructor(navigation: QnaNavigationService) {
    super(navigation, 'Accessibility');
  }
}
